// extracted by mini-css-extract-plugin
module.exports = {"projects":"ProjectCards_projects__VD8kw"};